<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Bidding Strategy</h2>
                      <div class="ims-tab ml-0">
                        <router-link to="/autobidder/biddingStrategy/list" class="inv-btn" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='biddingStrategylist' }" >
                            Bidding Strategy
                          </button>
                        </router-link>
                        <router-link to="/autobidder/biddingStrategy/history">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='biddingStrategyhistory' }" >
                            History
                          </button>
                        </router-link>
                        <router-link to="/autobidder/biddingStrategy/all" v-if="isAdmin">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='biddingStrategyhistoryAll' }" >
                            All Bidding Strategy
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div> 
        
</template>
<script>

export default {
  name: "bids",
  components : {

  },
  data() {
    return {
      isAdmin: false

    };
  },
  methods: {

  },
  mounted() {

    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        }
    });


  }
};
</script>